<template>
  <div v-if="schedule.interview_id">
    <a
      class="align-items-center svg-sm btn btn-sm pointer"
      @click.prevent="onClickAction(schedule.interview_id)"
      :class="{
        'btn-outline-danger': schedule.interview_status === 'initiated',
        'btn-outline-warning': schedule.interview_status === 'active',
        'btn-outline-success': schedule.interview_status === 'finished',
      }"
      v-if="schedule.interview_id"
    >
      <small class="uppercase svg-upper">
        <div class="d-flex flex-row align-items-center">
          <div class="pr-2">
            <SymptomCheckerIcon></SymptomCheckerIcon>
          </div>
          <div class="text-left">
            {{ $t("interview") }}
            <template v-if="schedule.interview_status === 'initiated'">
              {{ $t("interviewInited") }}
            </template>
            <template v-else-if="schedule.interview_status === 'active'">
              {{ $t("interviewActive") }}
            </template>
            <template v-else-if="schedule.interview_status === 'finished'">
              {{ $t("interviewFinished") }}
            </template>
            <template v-else-if="schedule.interview_status === 'cancelled'">
              {{ $t("interviewCancelled") }}
            </template>
          </div>
        </div>
      </small>
    </a>
  </div>
</template>
<script>
// import YesIcon from '@/components/Icons/Yes'
import SymptomCheckerIcon from '@/components/Icons/SymptomChecker'
import { mapGetters } from 'vuex'
export default {
  components: {
    // YesIcon,
    SymptomCheckerIcon
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      default: null
      // default: () => {
      //   return (id) => {
      //     console.log('asdfsafasd')
      //     if (this.authType === 'Doctor' && this.schedule.interview_status !== 'finished') {
      //       return
      //     }
      //     this.$router.push({ path: `/interview/${id}` })
      //   }
      // }
    }
  },
  completed: {
    ...mapGetters({
      authType: 'auth/type'
    })
  },
  methods: {
    onClickAction (id) {
      if (this.onClick != null) {
        return this.onClick(id)
      }
      if (this.authType === 'Doctor' && this.schedule.interview_status !== 'finished') {
        return
      }
      this.$router.push({ path: `/interview/${id}` })
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "interview": "AI დასკვნა",
    "interviewInited": "მოთხოვნილია",
    "interviewActive": "მიმდინარეობს",
    "interviewFinished": "მზადაა",
    "interviewCancelled": "გაუქმებულია"
  },
  "en": {
    "interview": "AI Results are",
    "interviewInited": "Requested",
    "interviewActive": "In Progress",
    "interviewFinished": "Ready",
    "interviewCancelled": "Cancelled"
  }
}
</i18n>
